<template>
	<el-container direction="vertical">
		<div class="colhead">
			<h2 class="header_h2">订单预约明细【{{orderent.OrderName}}】</h2>
		</div>
		<el-header>
			<el-input v-model="select_word" @input="FindTextChange()" placeholder="姓名查找"
				style="display:inline-block;width:200px;"></el-input>
				&emsp;预约日期过滤：<el-date-picker @change="FindDateChange()" v-model="qstart" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
				</el-date-picker> 到
				<el-date-picker @change="FindDateChange()" v-model="qend" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
				</el-date-picker>
		</el-header>
		<el-main>
			<el-table border ref="multipleTable" tooltip-effect="dark"
				:data="cuslist.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="cusname" label="姓名" width="160px"></el-table-column>
				<el-table-column prop="cussex" label="适用性别" width="100px">
					<template slot-scope="scope">
						<div v-for="item in AdaptSex">
							<label v-if='scope.row.cussex==item.value'>{{item.key}}</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="cusbirthday" label="出生日期" width="120px"></el-table-column>
				<el-table-column prop="idcard" label="证件号" width="200px"></el-table-column>
				<el-table-column prop="cusstatus" label="状态" width="100px">
					<template slot-scope="scope">
						<div v-for="item1 in CusStatus">
							<label v-if='scope.row.cusstatus==item1.value'>{{item1.key}}</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="bookdate" label="预约日期"width="120px">
					<template slot-scope="scope">
							<label v-if="scope.row.bookdate!=null">{{CommonFun.formatdate(scope.row.bookdate)}}</label>
					</template>
				</el-table-column>
				<el-table-column prop="branch_name" label="预约分院"></el-table-column>
				<el-table-column prop="book_type_name" label="预约类型"width="120px"></el-table-column>
			</el-table>
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-sizes="[10, 20, 40,80]" :page-size="pagesize"
							layout="total, sizes, prev, pager, next, jumper" :total="cuslist.length">
						</el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>
	</el-container>
</template>

<script>
	import ordercus from '../../apifunction/OrderCus.js'
	export default {
	created() {
		var ent = this.$route.query.ent;
		this.orderent = JSON.parse(ent);
			this.initData()
		},
		data() {
			return {
				orderent:null,
				cusAllList: [],
				cuslist: [],
				AdaptSex: this.$enums.AdaptSex,
				AdaptMarry: this.$enums.AdaptMarry,
				CusStatus: this.$enums.CusStatus,
				currentPage: 1,
				pagesize: 10,
				select_word: "",
qstart:this.CommonFun.GetNowDate(),
qend:this.CommonFun.GetNowDate()
			}
		},
		methods: {
			initData() {
				ordercus.GetBookDetailByOrderID(this.orderent.OrderID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.cusAllList = JSON.parse(ent.Data);
								this.cuslist = JSON.parse(ent.Data);
							} else
								this.cuslist = [];
						} else
							this.$message.info(ent.Msg);
					});

			},
			FindTextChange: function() {
				if (this.select_word == '') {
					this.cuslist = this.cusAllList;
					return;
				}
				//alert(py.chinesesToPY(this.SaleModuleListAll[0].SaleModuleName))
				var templist = this.cusAllList.filter(item => {
					if (item.cusname.indexOf(this.select_word) > -1) {
						//if (item.SaleModuleName.indexOf(this.txtFind) > -1) {
						return item
					}
				});
				this.cuslist = JSON.parse(JSON.stringify(templist));
			},
			FindDateChange:function() {
				if (this.cusAllList.length<1) {
					return;
				}
				var templist = this.cusAllList.filter(item => {
					if (item.bookdate>=this.qstart&&item.bookdate<=this.CommonFun.GetDateByAddDay(this.qend,1) ) {
						return item
					}
				});
				this.cuslist = JSON.parse(JSON.stringify(templist));
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
		},
		}
</script>

<style>
</style>
